import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `CompanySelectionRoot`,
  checkbox: `CompanySelectionCheckbox`,
  checkboxContent: `CompanySelectionCheckboxContent`,
  checkboxContentItem: `CompanySelectionCheckboxContentItem`
};

export function useCompanySelectionStyles() {
  const { spacing } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          marginTop: `${spacing.l2} !important`
        }
      ],
      checkbox: [
        classNames.checkbox,
        {
          paddingLeft: spacing.m,
          "& .ms-Checkbox-checkbox": {
            marginRight: `10px`,
            marginTop: `5px`
          },
          "& .ms-Checkbox-label": {
            width: `100%`,
            alignItems: `start`
          }
        }
      ],
      checkboxContent: [
        classNames.checkboxContent,
        {
          width: `100%`
        }
      ],
      checkboxContentItem: [
        classNames.checkboxContentItem,
        {
          paddingRight: `30px`
        }
      ]
    }),
    [spacing]
  );
}
